"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
var _Portal = _interopRequireDefault(require("./Portal"));
exports.default = _Portal.default;